module.exports = __webpack_public_path__ + "img/parent-btn.c7ce09ab.svg";